export type PagesTypes =
  | 'dashboard'
  | 'search'
  | 'dashboard/details'
  | 'dashboard/area'
  | 'productsList'
  | 'productDetails'
  | 'programDetails'
  | 'masterClassDetails'
  | 'productClassDetails'
  | 'productModule'
  | 'contentDetails'
  | 'contentClassDetails'
  | 'contentScormDetails'
  | 'productContentDetails'
  | 'productContentClassDetails'
  | 'productNoClassContent'
  | 'productEvolution'
  | 'productClassEvolution'
  | 'booksList'
  | 'liveDetails'
  | 'liveDetailsNoProduct'
  | 'liveDetailsJourney'
  | 'liveConfirmation'
  | 'liveDetailsZoom'
  | 'reportsList'
  | 'reportsByCategoryList'
  | 'livesList'
  | 'teacherDetails'
  | 'reportsList'
  | 'teachersList'
  | 'bookDetails'
  | 'account'
  | 'requests'
  | 'login'
  | 'logout'
  | 'register'
  | 'registerSuccess'
  | 'registerAppSuccess'
  | 'forgotPassword'
  | 'resetPassword'
  | 'changePassword'
  | 'myCourses'
  | 'myBadges'
  | 'productClassCheckout'
  | 'payments/contact'
  | 'payments/payment'
  | 'payments/success'
  | 'recommendations/details'

  // Journeys
  | 'journeys/details'
  | 'journeys/area'
  | 'journeys/area/lives'

  //Events
  | 'events/details'

  // Exams
  | 'exams/list'
  | 'exams/start'
  | 'exams/question'
  | 'exams/assessment'
  | 'exams/result'
  | 'offers/payment'
  | 'offers/success'
  | 'recommendations/details'
  | 'siteUrl'

  //MFA
  | 'mfa/activation'
  | 'mfa/disable'
  | 'mfa/support'

  //PERFIL DO ALUNO
  | 'account/certificates'
  | 'account/messages'
  | 'account/documents'
  | 'account/classdiary'
  | 'account/support'

  // Educational
  | 'educational/activate/code'
  | 'educational/register/switcher'
  | 'educational/register'
  | 'educational/register/success'
  | 'educational/reset-password';

const createUrl = (page: PagesTypes, args: any[] = []) => {
  const urls: Record<PagesTypes, string> = {
    'dashboard': '/',
    'search': '/search',
    'dashboard/details': '/dashboard/%1',
    'dashboard/area': '/dashboard/%1/area/%1',
    'productsList': '/products',
    'productDetails': '/products/%1',
    'programDetails': '/programs/%1',
    'masterClassDetails': '/masterclass/%1',
    'productClassDetails': '/products/%1/classes/%2',
    'productModule': '/products/%1/classes/%2/modules/%3',
    'contentDetails': '/products/%1/modules/%2/contents/%3/%4',
    'recommendations/details': '/products/%1/classes/%2/recommendations/%3',
    'contentClassDetails': '/products/%1/classes/%2/modules/%3/contents/%4/%5',
    'contentScormDetails': '/products/%1/classes/%2/scorm',
    'productContentDetails': '/products/%1/contents/%3/%4',
    'productContentClassDetails': '/products/%1/classes/%2/contents/%4/%5',
    'productNoClassContent': '/products/%1/contents/%4/%5',
    'productEvolution': '/products/%1/evolution',
    'productClassEvolution': '/products/%1/classes/%2/evolution',
    'productClassCheckout': '/products/%1/classes/%2/checkout',
    'payments/contact': '/products/%1/classes/%2/checkout/contact',
    'payments/payment': '/products/%1/classes/%2/checkout/payment',
    'payments/success': '/products/%1/classes/%2/checkout/success',
    'offers/payment': '/%1/checkout',
    'offers/success': '/%1/checkout/success',
    'booksList': '/books',
    'bookDetails': '/books/%1',
    'reportsList': '/reports/list',
    'reportsByCategoryList': '/reports/%1/list',
    'livesList': '/lives',
    'liveDetails': '/products/%1/classes/%2/lives/%3/video',
    'liveDetailsNoProduct': '/lives/%3/video',
    'liveDetailsJourney': '/lives/%1/%3/video',
    'liveConfirmation': '/lives/%1/attendanceconfirmation',
    'liveDetailsZoom': '/products/%1/classes/%2/lives/%3/zoom',
    'teacherDetails': '/teachers/%1',
    'teachersList': '/teachers',
    'account': '/account',
    'myCourses': '/account/courses',
    'myBadges': '/account/badges',
    'changePassword': '/account/change-password',
    'requests': '/requests',
    'login': '/login',
    'logout': '/logout',
    'register': '/register',
    'registerSuccess': '/register/success',
    'registerAppSuccess': '/app/register/success',
    'forgotPassword': '/forgot-password',
    'resetPassword': '/reset-password/%1',

    //Journeys
    'journeys/details': '/journeys/%1',
    'journeys/area': '/journeys/%1/areas/%2',
    'journeys/area/lives': '/journeys/%1/lives',
    // Events
    'events/details': '/events/%1/%2/%3',
    // Exams
    'exams/list': '/exams',
    'exams/start': '/exams/%1',
    'exams/assessment': '/exams/%1/assessment/%2',
    'exams/question': '/exams/%1/assessment/%2/question/%3',
    'exams/result': '/exams/%1/assessment/%2/result',
    'siteUrl': 'https://www.melver.com.br',

    'mfa/activation': '/mfa/activation',
    'mfa/disable': '/mfa/disable',
    'mfa/support': '/mfa/support',

    //PERFIL DO ALUNO

    'account/certificates': '/account/certificates',
    'account/messages': '/account/messages',
    'account/documents': '/account/documents',
    'account/classdiary': '/account/classdiary',
    'account/support': '/account/support',

    'educational/activate/code': '/educacional',
    'educational/register/switcher': '/educacional/selecao',
    'educational/register': '/educacional/cadastro',
    'educational/register/success': '/educacional/cadastro/sucesso',
    'educational/reset-password': '/educacional/alterar-senha',
  };

  //@ts-ignore
  return urls[page].replace(/%(\d+)/g, (_: number, n: number) => args[+n - 1]);
};

export default createUrl;
